<div class="product product--layout--{{ layout }}" *ngIf="product">
    <div class="product__content">
        <!-- .product__gallery -->
        <div class="product__gallery">
            <app-product-gallery [productLayout]="layout" [images]="product.images"></app-product-gallery>
        </div>
        <!-- .product__gallery / end -->
        <!-- .product__info -->
        <div class="product__info">
            <div *ngIf="product.categoryData">
                <h6 style="font-size: medium; color:rgba(102, 95, 95, 0.979);">{{translateHelper.localize(product.categoryData[0]?.name)}}</h6>
            </div>

            <h1 class="my-3" style="font-size: x-large; font-weight: bold;">{{ translateHelper.localize(product.name) }}</h1>

            <div class="product__availability">
                {{"item_code"|translate}}: <span class="ms-2" *ngIf="product.code">{{product.code}}</span>
            </div>

            <ul class="product__meta">
                <li class="product__meta-availability" *ngIf="product.quantity?.amount > 0">{{"availability"|translate}}: <span class="text-success">{{"in_stock"|translate}}</span></li>
                <li class="product__meta-availability" *ngIf="product.quantity?.amount <= 0">{{"availability"|translate}}: <span class="text-danger">{{"out_of_stock"|translate}}</span></li>
            </ul>

            <div class="product__prices">
                <ng-container *ngIf="product.name">
                    <span class="product__new-price" *ngIf="!product.hidePrice">{{ product.taxedPrice || product.price |currencyFormat }}</span>{{ ' ' }}
                </ng-container>
                <div *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                    <span style="font-size:  small;" class="my-2">{{"inclusive"|translate}}</span>
                </div>

            </div>
            <div *ngIf="product.options">
                <app-product-options [baseForm]="form" [optionsObject]="product?.options" [product]="product">
                </app-product-options>
            </div>
        </div>
        <!-- .product__info / end -->
        <!-- .product__sidebar -->
        <div class="product__sidebar">
            <div *ngIf="product.companyData.length > 0" class="mt-4 sm:mt-2 vendor-info">
                <div class="mb-2" *ngIf="product.companyData" fxLayout="row" fxLayoutAlign="center center">
                    <img *ngIf="product?.companyData?.design" [src]="product.companyData?.design?.logo?.thumb?.url || product.companyData?.design.logo.url" [routerLink]="['/vendor', product.companyData?.seo?.slug]" style="cursor: pointer;" width="100px">
                </div>

                <div class="vendor-info-content">
                    <div class="vendor-info-name pb-4 ">
                        <a class="text-base lg:text-sm" style="font-size: 18;" [routerLink]="['/vendor', product.companyData?.seo?.slug]">{{translateHelper.localize(product.companyData?.name)}}</a>
                    </div>
                    <div class="vendor-info-actions">
                        <button eventCollector eventName="message" category="service_page" [companyId]="product.companyData?._id" [itemType]="product.type" [productId]="product._id" *ngIf="userDetails" class="btn btn-primary w-full" type="button" (click)="askVendor()">{{"ask_vendor"|translate}}</button>
                    </div>
                </div>
            </div>
            <mat-expansion-panel class="mb-2 mat-elevation-z0" expanded="false" *ngFor="let contentBlock of product.contentBlocks">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="pr-2">{{contentBlock.icon}}</mat-icon> {{contentBlock.header}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="contentBlock.content"></div>
            </mat-expansion-panel>

            <ng-container *ngIf="!product.contentBlocks?.length || product.contentBlocks?.length == 0">
                <mat-expansion-panel class="mb-2 mat-elevation-z0" expanded="false" *ngFor="let contentBlock of product.companyData?.contentBlocks">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="pr-2">{{contentBlock.icon}}</mat-icon> {{contentBlock.header}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="contentBlock.content"></div>
                </mat-expansion-panel>
            </ng-container>
        </div>
    </div>
</div>